import { PaperClipIcon } from "Assets/icons/v2";
import React, { useEffect, useRef, useState } from "react";
import 'Assets/css/common.css'
import GreySvgCross from "Assets/images/GreySvgCross";

function DocumentPicker({ label = "", required, value, onChange }) {
    const fileRef = useRef(null);
    const [fileName, setFileName] = useState("");

    const handleClick = () => {
        fileRef.current.click();
    };
    console.log('hihihi', value);

    useEffect(() => {
        if (typeof value === "string") {
            const name = value.split("/").pop();
            setFileName(name);
        } else {
            setFileName("");
        }
    }, [value]);

    const handleChange = (e) => {
        let file = e.target.files[0]
        if (e.target.files?.length) {
            setFileName(e.target.files[0].name);
            onChange?.(file)
        }
    };
    const handleRemove = (e) => {
        e.preventDefault();
        e.stopPropagation();

        onChange?.(null);
        setFileName?.("");

        if (fileRef.current) {
            fileRef.current.value = "";
        }
    };
    return (
        <div className="row justify-content-between align-items-center">
            {
                label && <div className="doc-label">
                    <h3 className="document-title">
                        {label} {required && <span>*</span>}
                    </h3>
                </div>
            }

            {/* Input */}
            <div className="doc-input">
                <div className="input-container" onClick={handleClick}>
                    <span className={`text-truncate ${fileName ? "text-dark" : "text-muted"}`}>
                        {fileName || ""}
                    </span>
                    {
                        !fileName && <PaperClipIcon />
                    }
                </div>
                {fileName && (
                    <span
                        className="cursor-pointer text-danger remove-icon"
                        onClick={handleRemove}
                    >
                        <GreySvgCross />
                    </span>
                )}

                <input
                    ref={fileRef}
                    type="file"
                    className="d-none"
                    onChange={handleChange}
                />
            </div>
        </div>

    );
}

export default DocumentPicker;
